/* Only Folate PDP links scroll; the purchase form keeps its normal cart flow. */
(() => {
  if (document.body.dataset.productHandle !== 'myo-inositol-d-chiro-inositol-folate-and-vitamin-d' ||
      !document.body.classList.contains('template-product-ir-inositol-folate')) return;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#ir-pdp-buy"]');
    const target = document.getElementById('ir-pdp-buy');
    if (!link || !target || !link.closest('main')) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    const header = document.querySelector('.section-header');
    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    const panel = target.closest('.ir-purchase-panel') || target;
    const top = panel.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
    target.focus({ preventScroll: true });
    window.scrollTo({
      top: Math.max(0, top),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    });
  }, true);
})();
